import React from 'react';
import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import styles from './TextSection.module.scss';
import useHover from '@react-hook/hover';

import { default as QuestionIcon } from '@static/img/icons/question.svg';

import DiamondElement from './diamond-element.svg';
import DiamondElement2 from './diamond-element-2.svg';

const TextSection: PageComponent = () => {
    const target = React.useRef(null);
    const targetTooltip = React.useRef(null);
    const isHovering = useHover(target, { enterDelay: 100, leaveDelay: 200 });
    const isHoveringTooltip = useHover(targetTooltip, {
        enterDelay: 100,
        leaveDelay: 200,
    });
    return (
        <section className={styles.section}>
            <div className="container">
                <h1 className={styles.title}>
                    <Trans
                        i18nKey="loyalty.title"
                        ns="landingInformationLoyalty"
                    >
                        Lojalumo programa
                    </Trans>
                </h1>
                <p className={styles.desc}>
                    <Trans
                        i18nKey="loyalty.description"
                        ns="landingInformationLoyalty"
                    >
                        Ši sistema skirta VPS paslaugų vartotojams, kurie kuo
                        ilgiau naudodami mūsų paslaugas gauna didesnį resursų
                        kiekį už tą pačią kainą.
                    </Trans>
                </p>
                <p className={styles.desc}>
                    <Trans
                        i18nKey="loyalty.subtitle"
                        ns="landingInformationLoyalty"
                    >
                        Už kiekvieną mėnesį naudodamasis mūsų paslaugomis
                        gaunate:
                    </Trans>
                </p>
            </div>
            <div className={styles.background_diamonds}>
                <div className={`container ${styles.diamond_container}`}>
                    <DiamondElement className={styles.left_shape} />
                    <div className={styles.diamond}>
                        <div className={styles.diamond_inner}>
                            <span>+</span>
                            <span>
                                <Trans
                                    i18nKey="loyalty.reward.value"
                                    ns="landingInformationLoyalty"
                                >
                                    2% RAM
                                </Trans>
                            </span>
                            <p>
                                <Trans
                                    i18nKey="loyalty.reward.text"
                                    ns="landingInformationLoyalty"
                                >
                                    gali išaugti net iki 50%!
                                </Trans>
                            </p>
                            <div className={styles.question_icon} ref={target}>
                                <QuestionIcon />
                            </div>
                            <div
                                className={styles.question_tooltip}
                                style={{
                                    display:
                                        isHovering || isHoveringTooltip
                                            ? 'block'
                                            : 'none',
                                }}
                                ref={targetTooltip}
                            >
                                <Trans
                                    i18nKey="loyalty.reward.tooltip"
                                    ns="landingInformationLoyalty"
                                >
                                    Resursas skaičiuojamas kiekvienam VPS planui
                                    atskirai. Pavyzdžiui, turite du VPS planus,
                                    vienas galioja mėnesį - jam bus pritaikyta
                                    2%, o kitas metus - jam bus pritaikyta 24%
                                    papildomos operatyviosios atminties.
                                </Trans>
                            </div>
                        </div>
                    </div>
                    <DiamondElement2 className={styles.right_shape} />
                </div>
            </div>
        </section>
    );
};

export default TextSection;
